




import { AuthService } from "@/common/api";
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import qNotify from "@/common/qNotify";

const auth = namespace("MemberAuth");

@Component({
  name: "callbackUpdateLine",
  components: {},
  directives: {},
})
export default class CallbackUpdateLine extends Vue {
  @auth.Getter
  userLogging: any;
  @auth.Action
  updateToken!: (token: string) => void;
  @auth.Action
  updateExpiredAt!: (time: string) => void;
  @auth.Action
  updateRole!: (role: string) => void;
  @auth.Action
  setUser!: (user) => void;
  @auth.Action
  fetchCurrentUser!: () => void;

  loginLineUrl = "";
  errors = {};

  public created() {
    console.log("OK");
  }

  public mounted() {
    this.updateLineAccountId();
  }

  private async updateLineAccountId() {
    let response = null;
    try {
      response = await AuthService.lineUpdateCallback({
        code: this.$route.query.code.toString(),
      });
    } catch (error) {
      response = error.body;
      this.errors = response.errors;
      localStorage.setItem("error_same_line_id", response.message);
    }

    if (response.status == "error") {
      qNotify.error({
        text: response.message,
      });
    } else {
      await this.fetchCurrentUser();
    }

    console.log("response", response);

    this.$router.push({ name: "mypage" });
  }
}
